module.exports = __webpack_public_path__ + "static/media/lock.a2676588.svg";